
import moment from "moment";
import { mapGetters } from "vuex";
import CalendarCheck from "vue-material-design-icons/CalendarCheck.vue";
import ChevronLeft from "vue-material-design-icons/ChevronLeft.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";

export default {
  name: "app-agendamento-publico",
  components: {
    CalendarCheck,
    ChevronLeft,
    ChevronRight,
  },
  data() {
    return {
      loading: true,
      saving: false,
      error: "",
      link: {},
      slots: [],
      selectedDay: "",
      selectedSlot: null,
      confirmedSlot: null,
      idPessoa: "",
      observacoes: "",
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    disabledSlotsCount() {
      return this.slots.filter((slot) => this.isSlotPast(slot)).length;
    },
    availableSlotsCount() {
      return this.slots.length - this.disabledSlotsCount;
    },
    availableDays() {
      const days = [];
      const byDay = {};

      this.slots.forEach((slot) => {
        const key = this.slotDayKey(slot);

        if (!byDay[key]) {
          const date = moment(slot.inicio);
          byDay[key] = {
            key,
            label: date.format("DD/MM"),
            longLabel: date.format("DD [de] MMMM [de] YYYY"),
            weekday: this.capitalize(date.format("dddd")),
            total: 0,
            available: 0,
          };
          days.push(byDay[key]);
        }

        byDay[key].total += 1;

        if (!this.isSlotPast(slot)) {
          byDay[key].available += 1;
        }
      });

      return days.sort((a, b) => a.key.localeCompare(b.key));
    },
    activeDayKey() {
      if (
        this.selectedDay &&
        this.availableDays.some((day) => day.key === this.selectedDay)
      ) {
        return this.selectedDay;
      }

      const firstAvailable = this.availableDays.find((day) => day.available);

      return firstAvailable
        ? firstAvailable.key
        : this.availableDays.length
        ? this.availableDays[0].key
        : "";
    },
    activeDay() {
      return this.availableDays.find((day) => day.key === this.activeDayKey);
    },
    activeDayIndex() {
      return this.availableDays.findIndex(
        (day) => day.key === this.activeDayKey
      );
    },
    activeDaySlots() {
      if (!this.activeDayKey) {
        return [];
      }

      return this.slots.filter(
        (slot) => this.slotDayKey(slot) === this.activeDayKey
      );
    },
    hasPreviousDay() {
      return this.activeDayIndex > 0;
    },
    hasNextDay() {
      return (
        this.activeDayIndex >= 0 &&
        this.activeDayIndex < this.availableDays.length - 1
      );
    },
  },
  methods: {
    async loadHorarios() {
      if (this.confirmedSlot) return;

      this.loading = true;
      this.error = "";

      try {
        const { data } = await this.$http.get(
          `/agendamentos/publico/${this.$route.params.token}/horarios`
        );
        this.link = data.link || {};
        this.slots = data.slots || [];
        if (this.selectedSlot && this.isSlotPast(this.selectedSlot)) {
          this.selectedSlot = null;
        }
        this.ensureSelectedDay();
      } catch (error) {
        this.error =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível carregar este link.";
      } finally {
        this.loading = false;
      }
    },
    async confirmar() {
      if (!this.selectedSlot || this.isSlotPast(this.selectedSlot)) return;

      if (!this.link.id_pessoa && !this.idPessoa) {
        this.$toast.warning("Informe o código do cliente.");
        return;
      }

      this.saving = true;
      const slotConfirmado = { ...this.selectedSlot };

      try {
        await this.$http.post(
          `/agendamentos/publico/${this.$route.params.token}/confirmar`,
          {
            id_pessoa: this.link.id_pessoa || this.idPessoa,
            data_inicio: this.selectedSlot.inicio,
            observacoes: this.observacoes,
          }
        );

        this.confirmedSlot = slotConfirmado;
        this.selectedSlot = null;
        this.slots = [];
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.msg ||
            error?.response?.data?.message ||
            "Não foi possível confirmar este horário."
        );
      } finally {
        this.saving = false;
      }
    },
    formatDate(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    formatTime(value) {
      return moment(value).format("HH:mm");
    },
    slotDayKey(slot) {
      return moment(slot.inicio).format("YYYY-MM-DD");
    },
    isSlotPast(slot) {
      return moment(slot.inicio).isBefore(moment());
    },
    selectSlot(slot) {
      if (this.isSlotPast(slot)) return;
      this.selectedDay = this.slotDayKey(slot);
      this.selectedSlot = slot;
    },
    changeDay(dayKey) {
      if (this.selectedDay !== dayKey) {
        this.selectedSlot = null;
      }

      this.selectedDay = dayKey;
    },
    goToPreviousDay() {
      if (!this.hasPreviousDay) return;
      this.changeDay(this.availableDays[this.activeDayIndex - 1].key);
    },
    goToNextDay() {
      if (!this.hasNextDay) return;
      this.changeDay(this.availableDays[this.activeDayIndex + 1].key);
    },
    ensureSelectedDay() {
      if (!this.availableDays.length) {
        this.selectedDay = "";
        return;
      }

      if (
        this.selectedDay &&
        this.availableDays.some((day) => day.key === this.selectedDay)
      ) {
        return;
      }

      const firstAvailable = this.availableDays.find((day) => day.available);
      this.selectedDay = firstAvailable
        ? firstAvailable.key
        : this.availableDays[0].key;
    },
    capitalize(value) {
      if (!value) return "";
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  created() {
    moment.locale("pt-br");
    this.loadHorarios();
  },
};
